/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

export interface IFieldGroupProps {
	grow?: boolean;
	className?: string;
}

export const FieldGroup: FC<IFieldGroupProps> = ({ children, grow, className }) => {
	const baseClass = BEM("edt-field-group", null, {
		grow: grow !== undefined ? grow : true
	});

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
